import React from 'react'
import Footer from '../components/Footer'
import ServicesSection from '../components/ServicesSection'

const Services = () => {
  return (
    <div>
        <ServicesSection showAll={true} marginTop="mt-24" />
        <Footer />
    </div>
  )
}

export default Services